import { Route, Switch } from 'react-router-dom'
import { mobileVersion } from '../types/constants'
import UserManagement from './AdminPanel/UserManagement/UserManagementFunctional'
import AssignToGroup from './AdminPanel/GroupsAdminPanel/assignToGroup/AssignToGroup'
import CompaniesAdminPanel from './AdminPanel/CompaniesAdminPanel/CompaniesAdminPanel'
import UsersAdminPanel from './AdminPanel/UsersAdminPanel/UsersAdminPanel'
import NavigateToUrl from './common/NavigateToUrl/NavigateToUrl'
import NotFound from './common/NotFound/NotFound'
import DashBoardComponent from './DashBoard/DashBoardComponent'
import ErrorsComponent from './Errors/ErrorsComponent'
import GeneralPage from './GeneralPage/GeneralPage'
import RequestList from './Orders/RequestList/RequestList'
import RequestEdit from './Orders/RequestEdit/RequestEdit'
import EditGroupFuelCardSet from './RequestsAdminPanel/GroupFuelCardSets/EditGroupFuelCardSet/EditGroupFuelCardSet'
import { EditFuelCard } from './RequestsAdminPanel/GroupFuelCardSets/FuelCardList/EditFuelCard/EditFuelCard'
import { FuelCardList } from './RequestsAdminPanel/GroupFuelCardSets/FuelCardList/FuelCardList'
import GroupFuelCardSets from './RequestsAdminPanel/GroupFuelCardSets/GroupFuelCardSets'
import NewWorkflow from './RequestsAdminPanel/NewWorkflow/NewWorkflow'
import { Translations } from './Translations/Translations'
import UserPreferences from './UserPreferences/UserPreferencesFunctional'
import EditSupplierWorkflowForm from './RequestsAdminPanel/SupplierWorkflows/Form/EditSupplierWorkflowForm'
import AvailableReports from './Reports/AvailableReports'
import { OrderContract } from './Orders/OrderContract/OrderContractComponent'
import CarDamages from './CarDamages/CarDamages'
import { Delivery } from './DeliveryAndReturns/Delivery'
import { ContractCostKindDetails } from './ContractCostKindDetails/ContractCostKindDetails'
import DeltaContracts from './DeltaContracts/DeltaContracts'
import { ContractDetails } from './ContractDetails/ContractDetails'
import { RequestsAdminPanelFunctional } from './RequestsAdminPanel/RequestAdminPanelFunctional'
import { NewForm } from './RequestsAdminPanel/NewForm/NewForm'
import { ReportAdminPanelFunctional } from './ReportsAdminPanel/ReportsAdminPanelFunctional'
import WorkflowsListFunctional from './RequestsAdminPanel/WorkflowsList/WorkflowsListFunctional'
import SupplierWorkflowsFunctional from './RequestsAdminPanel/SupplierWorkflows/SupplierWorkflowsFunctional'
import { ReleaseNotes } from './ReleaseNotes/ReleaseNotes'
import { GeneralContractsFunctional } from './GeneralContracts/GeneralContractsFunctional'
import { GroupsAdminPanelFunctional } from './AdminPanel/GroupsAdminPanel/GroupsAdminPanelFunctional'
import AddNewGroupFunctional from './AdminPanel/GroupsAdminPanel/addNewGroup/AddNewGroupFunctional'
import { ReportEdit } from './ReportsAdminPanel/ReportEdit/ReportEdit'
import { DatabaseReportView } from './Reports/DatabaseReportView'
import { UserEdit } from './AdminPanel/UsersAdminPanel/UserEdit/UserEdit'
import { SupplierWorkflowEdit } from './RequestsAdminPanel/SupplierWorkflows/SupplierWorkflowEdit/SupplierWorkflowEdit'
import NotificationsAdminPanel from './AdminPanel/Notifications/NotificationsAdminPanel'

interface IRouteProps {
  isAdmin?: boolean
  isInternalUser?: boolean
  isManager?: boolean
  canManageOrders?: boolean
  viewCosts?: boolean
  newDCallowed?: boolean
  userTenant?: string
}

/**
 * Return available routes when user is logged.
 */
function Routes(props: IRouteProps) {
  const adminPanelRoutes = [
    <Route path={`/translations`} component={Translations} exact={true} key="16" />,
    <Route path={`/UserManagement/groups/group/edit/:id`} component={AddNewGroupFunctional} exact={true} key="17" />,
    <Route path={`/RequestsManagement`} component={RequestsAdminPanelFunctional} exact={true} key="25" />,
    <Route path={`/RequestsManagement/EditForm/:id`} component={NewForm} exact={true} key="26" />,
    <Route path={`/RequestsManagement/EditWorkflow/:id`} component={NewWorkflow} exact={true} key="27" />,
    <Route path={`/RequestsManagement/Workflows`} component={WorkflowsListFunctional} exact={true} key="28" />,
    <Route path={`/ReportsManagement`} component={ReportAdminPanelFunctional} exact={true} key="129" />,

    <Route path={`/ReportsManagement/EditForm/:id`} component={ReportEdit} exact={true} key="30" />,
    <Route path={`/RequestsManagement/GroupFuelCardSets`} component={GroupFuelCardSets} exact={true} key="31" />,
    <Route path={`/RequestsManagement/GroupFuelCardSets/:id`} component={EditGroupFuelCardSet} exact={true} key="32" />,
    <Route path={`/RequestsManagement/FuelCards`} component={FuelCardList} exact={true} key="33" />,
    <Route path={`/RequestsManagement/FuelCards/:id`} component={EditFuelCard} exact={true} key="34" />,

    <Route
      path={`/RequestsManagement/SupplierWorkflows`}
      component={SupplierWorkflowsFunctional}
      exact={true}
      key="35"
    />,
    <Route
      path={`/RequestsManagement/EditSupplierWorkflow/:id`}
      component={EditSupplierWorkflowForm}
      exact={true}
      key="36"
    />,
    <Route
      path={`/RequestsManagement/EditSupplierWorkflowNew/:id`}
      component={SupplierWorkflowEdit}
      exact={true}
      key="366"
    />,
    <Route path={`/NotificationsManagement`} component={NotificationsAdminPanel} exact={true} key="37" />,
  ]

  const adminOrInternalManager = [
    <Route path={`/UserManagement/groups/assignToGroup/:groupId`} component={AssignToGroup} exact={true} key="18" />,
    <Route path={`/UserManagement/users/newUserEdit/:id`} component={UserEdit} exact={true} key="20" />,
  ]

  const internalRoutes = [
    <Route path={`/UserManagement`} component={UserManagement} exact={true} key="1" />,
    <Route path={`/UserManagement/groups`} component={GroupsAdminPanelFunctional} exact={true} key="2-new" />,
    <Route path={`/UserManagement/companies`} component={CompaniesAdminPanel} exact={true} key="3" />,
    <Route path={`/UserManagement/users`} component={UsersAdminPanel} exact={true} key="4" />,
    <Route path={`/UserManagement/users/newUserEdit/:tenant/:id`} component={UserEdit} exact={true} key="5" />,
    <Route
      path={`/UserManagement/users/newUserEdit/:tenant/:id/duplicate`}
      component={UserEdit}
      exact={true}
      key="6"
    />,
    <Route path={`/damages`} component={CarDamages} exact={true} key="7" />,
  ]

  const mobileVersionRoutes = [
    <Route path={`/requests/:orderId`} component={RequestEdit} exact={true} />,
    <Route path={`/`} component={RequestList} exact={true} />,
  ]

  const viewCostsRoutes = [
    <Route path="/deltaContracts" component={DeltaContracts} exact={true} key="1" />,
    <Route path="/deltaContracts/:companyId" component={DeltaContracts} exact={true} key="2" />,
  ]

  return (
    <>
      <Switch>
        <Route path="/" component={NavigateToUrl} exact={false} />
      </Switch>
      {mobileVersion ? (
        <Switch>
          {mobileVersionRoutes.map((r) => r)}
          <Route component={NotFound} />
        </Switch>
      ) : (
        <Switch>
          {props.isInternalUser ? (
            <Route path="/" component={GeneralPage} exact={true} />
          ) : (
            <Route path="/" component={DashBoardComponent} exact={true} />
          )}
          {props.isInternalUser && internalRoutes.map((r) => r)}
          {props.isAdmin && adminPanelRoutes.map((r) => r)}
          {props.viewCosts && viewCostsRoutes.map((r) => r)}
          {(props.isAdmin || (props.isInternalUser && props.isManager)) && adminOrInternalManager.map((r) => r)}
          <Route path="/generalContracts" component={GeneralContractsFunctional} exact={true} key="601-new" />
          <Route
            path="/generalContracts/:companyId"
            component={GeneralContractsFunctional}
            exact={true}
            key="602-new"
          />
          <Route
            path="/generalContracts/:companyId/expiringContracts/:daysAmount"
            component={GeneralContractsFunctional}
            exact={true}
            key="603-new"
          />
          <Route path="/orderAndDelivery" component={Delivery} exact={true} />
          <Route path="/orderAndDelivery/:companyId" component={Delivery} exact={true} />
          <Route path="/userPreferences" component={UserPreferences} exact={true} />
          <Route path={`/generalContracts/details/:id`} component={ContractDetails} exact={true} key="606" />
          <Route path={`/orderAndDelivery/details/:id`} component={ContractDetails} exact={true} key="607" />
          <Route path={`/generalContracts/details/:id/:kind`} component={ContractCostKindDetails} exact={true} />
          <Route path={`/orderAndDelivery/details/:id/:kind`} component={ContractCostKindDetails} exact={true} />
          <Route path={`/reports`} component={AvailableReports} exact={true} />
          <Route path={`/reports/:reportId`} component={DatabaseReportView} exact={true} />
          <Route path={`/reports/:reportId/force/:force`} component={DatabaseReportView} exact={true} />
          <Route path={`/errors`} component={ErrorsComponent} exact={true} />
          <Route path={`/requests/:orderId`} component={RequestEdit} exact={true} />
          {props.isInternalUser && <Route path={`/requests/:orderId/view=dcs`} component={RequestEdit} exact={true} />}
          <Route path={`/requests/:orderId/view=html`} component={RequestEdit} exact={true} />
          <Route path={`/requests/:orderId/view=pdf`} component={RequestEdit} exact={true} />
          <Route path={`/requests/:orderId/contract`} component={OrderContract} exact={true} />
          {props.canManageOrders && <Route path={`/requests/new/:formId`} component={RequestEdit} exact={true} />}
          {props.canManageOrders && (
            <Route path={`/requests/new/:formId/contract/:contractId`} component={RequestEdit} exact={true} />
          )}
          {props.canManageOrders && props.isInternalUser && (
            <Route path={`/requests/new/:formId/view=dcs`} component={RequestEdit} exact={true} />
          )}
          {props.canManageOrders && (
            <Route path={`/requests/new/:formId/view=html`} component={RequestEdit} exact={true} />
          )}
          <Route path={`/requests`} component={RequestList} exact={true} />
          {props.isInternalUser ? <Route path="/dashboard" component={DashBoardComponent} exact={true} /> : null}
          {props.isInternalUser ? (
            <Route path="/dashboard/:companyId" component={DashBoardComponent} exact={true} />
          ) : (
            <Route path="/dashboard-home/:companyId" component={DashBoardComponent} exact={true} />
          )}
          {props.isInternalUser ? (
            <Route path="/dashboard/:companyId/treeview" component={DashBoardComponent} exact={true} />
          ) : (
            <Route path="/dashboard-home/:companyId/treeview" component={DashBoardComponent} exact={true} />
          )}
          <Route path={`/releaseNotes`} component={ReleaseNotes} exact={true} />
          <Route component={NotFound} />
        </Switch>
      )}
    </>
  )
}

export default Routes
